// Employee/styles/header.ts
import {Theme} from "@mui/material/styles";

export const styles = {
    viewButton: (theme: Theme) => ({
        backgroundColor: "none",
        color: "#90caf9",
        border: "1px solid #90caf9",
        marginTop: "0.8rem",
        "&:hover": {
            backgroundColor: "#333",
        },
        "&.MuiButton-outlined": {
            border: "1px solid #90caf9",
        },
        "&.MuiButton-contained": {
            backgroundColor: "#90caf9",
            color: "#1e1e1e",
        },
        [theme.breakpoints.down('sm')]: {
            padding: '4px 8px',
            fontSize: '0.8rem',
        },
    }),
    navButtons: (theme: Theme) => ({
        "& button": {
            backgroundColor: "none",
            color: "#90caf9",
            border: "1px solid #90caf9",
            "&:hover": {
                backgroundColor: "#333",
            },
        },
        [theme.breakpoints.down('sm')]: {
            padding: "0 0.5rem",
            marginTop: "0.5rem",
        },
    }),
    timeZoneSelectItems: (theme: Theme) => ({
        border: "1px solid #90caf9",
        "&:hover": {
            backgroundColor: "#333",
        },
        fontSize: "0.9rem",
        [theme.breakpoints.down('sm')]: {
            fontSize: "0.8rem",
        },
        "& .MuiSelect-select": {
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#90caf9",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#90caf9",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#90caf9",
        },
    }),
};